var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDemonstrations = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.318 4.107c0-.905-.791-1.696-1.696-1.696s-1.695.79-1.695 1.696v6.217h3.39zM13.796 5.237c0-.905-.79-1.696-1.695-1.696s-1.696.791-1.696 1.696v5.087h3.391zM25.665 3.541c-.904 0-1.695.791-1.695 1.696v4.522c0 .904.79 1.695 1.695 1.695s1.696-.79 1.696-1.695V5.237c0-.905-.79-1.696-1.696-1.696M21.144 11.454c.905 0 1.695-.79 1.695-1.695V4.107c0-.905-.79-1.696-1.695-1.696s-1.696.79-1.696 1.696v5.652c0 .904.79 1.695 1.696 1.695M27.361 12.02v7.347c0 1.922-1.018 3.391-2.26 3.391v9.217H12.665v-9.262c-2.556-.401-4.522-3.508-4.522-7.302v-1.696a2.27 2.27 0 0 1 2.261-2.26h7.348c.904 0 1.695.791 1.695 1.695 0 .903-.79 1.695-1.695 1.695h-5.087c-.339 0-.565.227-.565.566s.226.565.565.565h.565c2.148 0 3.956 1.808 3.956 3.956 0 .34.227.565.566.565s.565-.225.565-.565c0-1.583-.791-3.051-1.921-3.956h1.356a2.8 2.8 0 0 0 2.826-2.826c0-.226-.113-.451-.113-.678.227.113.452.113.678.113.905 0 1.695-.452 2.26-1.13.566.678 1.358 1.13 2.261 1.13.678 0 1.244-.226 1.696-.566"
  })));
};
export default SvgDemonstrations;